// extracted by mini-css-extract-plugin
module.exports = {"textSlide":"_1xYchA9g","contentBody":"_2sburjN2"};